import React, { useMemo } from "react"
import { useTheme, useMediaQuery } from "@material-ui/core"
import { Trans } from "@lingui/macro"
import { renderMobileButtons, renderDesktopButtons, useStyles } from "./KnowledgeArticleButtons"

const KnowledgeArticleSaveButton = ({
  isEditing,
  loading,
  copyLoading,
  onCancel,
  onSave,
  onSaveNewVersion,
  canEdit,
  canCopy
}) => {
  const theme = useTheme()
  const classes = useStyles({ theme })
  const xs = useMediaQuery(theme.breakpoints.down("xs"))
  const buttonText = useMemo(() => {
    if (loading) return <Trans>Saving...</Trans>
    if (isEditing) return <Trans>Save</Trans>
    return <Trans>Edit content</Trans>
  }, [loading, isEditing])

  if (xs) {
    return renderMobileButtons({
      classes,
      canEdit,
      isEditing,
      loading,
      onSave,
      onCancel
    })
  }

  return renderDesktopButtons({
    classes,
    canEdit,
    canCopy,
    isEditing,
    loading,
    copyLoading,
    onSave,
    onCancel,
    onSaveNewVersion,
    buttonText
  })
}

export { KnowledgeArticleSaveButton }
